import {
  forwardRef,
  Ref,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import RefreshControl, { RefreshControlProps } from "./RefreshControl";

const StaticRefreshControl = forwardRef(
  (
    {
      value,
      onRefresh: onRefresh_,
      ...rest
    }: Omit<RefreshControlProps, "dataUpdatedAt" | "onClick"> & {
      onRefresh?: () => void;
    },
    ref: Ref<HTMLDivElement>,
  ) => {
    const [updatedAt, setUpdatedAt] = useState<number>(Date.now());

    const onRefresh = useRef(onRefresh_);
    onRefresh.current = onRefresh_;

    const interval = useRef<ReturnType<typeof setInterval>>();

    const startInterval = useCallback((value: number) => {
      if (interval.current) {
        clearInterval(interval.current);
      }

      setUpdatedAt(Date.now());

      interval.current = setInterval(() => {
        onRefresh.current?.();
        setUpdatedAt(Date.now());
      }, value * 1000);
    }, []);

    useEffect(() => {
      if (value) {
        startInterval(value);

        return () => {
          if (interval.current) {
            clearInterval(interval.current);
          }
        };
      }
    }, [startInterval, value]);

    return (
      <RefreshControl
        value={value}
        dataUpdatedAt={updatedAt}
        disableSelection
        onClick={() => {
          onRefresh.current?.();
          if (value) {
            startInterval(value);
          }
        }}
        ref={ref}
        {...rest}
      />
    );
  },
);

export default StaticRefreshControl;
